import { computed } from 'vue';
import { ORDER_STATUS } from '@/enums/session';
import { useSessionStore } from '@/store/modules/session';
import { useUserStore } from '@/store/modules/user';

const CONSULT_INFO_HIDDEN_SKILL_GROUP_ID = 'sg000000000000000002';

export function useActionShow() {
    function canClose(createUserId?: string, status?: ORDER_STATUS) {
        return status !== ORDER_STATUS.CLOSED;
    }

    function canResolve(dealUserId?: string, status?: ORDER_STATUS) {
        return status === ORDER_STATUS.PROCESSING;
    }

    function canReOpen(createUserId?: string, status?: ORDER_STATUS) {
        return status === ORDER_STATUS.SOLVED;
    }

    return {
        canClose,
        canResolve,
        canReOpen
    };
}

export function useSessionConsultInfoVisible() {
    const sessionStore = useSessionStore();
    const userStore = useUserStore();

    const showSessionConsultInfo = computed(() => {
        const sessionBaseInfo = sessionStore.sessionBaseInfo;
        const skillGroupId = sessionBaseInfo?.kfSkillGroupId;
        const isCurrentSession =
            !sessionBaseInfo?.groupId || sessionBaseInfo.groupId === sessionStore.groupID;

        return (
            userStore.userInfo.kfType === 1 &&
            isCurrentSession &&
            Boolean(skillGroupId) &&
            skillGroupId !== CONSULT_INFO_HIDDEN_SKILL_GROUP_ID
        );
    });

    return {
        showSessionConsultInfo
    };
}
